import React, {memo} from 'react';
import {View, Text, StyleProp, TextStyle} from 'react-native';

import { StyleSheet } from 'react-native';
import {colorPalette} from '../../../core/config/color.config';

import {RNEText} from '../../components';

import {formatToMessageTime} from '../../utils/date.utils';
import { width, height, totalSize } from 'react-native-dimension';

interface ConsultationRequestMessageProps {
  message: string;
  timestamp: Date;
  owner?: boolean;
}

const ConsultationRequestMessage = (props: ConsultationRequestMessageProps) => {
  

  return (
    <View>
      <View style={styles.timestamp}>
        <RNEText
          label={formatToMessageTime(props.timestamp)}
          color="grey"
          variant="button"
          weight="600"
        />
      </View>
      <View
        style={[
          styles.messageContainer,
          // eslint-disable-next-line react-native/no-inline-styles
          {
            alignItems: props.owner ? 'flex-end' : 'flex-start',
          },
        ]}>
        <View
          style={[
            styles.messageWrapper,
            // eslint-disable-next-line react-native/no-inline-styles
            {
              borderTopRightRadius: props.owner ? 0 : 12,
              borderTopLeftRadius: props.owner ? 12 : 0,
            },
          ]}>
          <RNEText
            label="Consultation Request"
            color="white"
            variant="button"
            weight="600"
          />
          <RNEText label={props.message} color="white" variant="button" />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  timestamp: {
    alignItems: 'center',
    marginTop: height(1),
  },
  messageContainer: {
    marginTop: height(1.5),
  },
  messageWrapper: {
    width: '60%',
    backgroundColor: colorPalette.purple,
    padding: height(2),
    paddingLeft: width(6),
    paddingRight: width(6),
    borderRadius: totalSize(2),
  },
}); 

export default memo(ConsultationRequestMessage);
